var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c(
            "div",
            { staticClass: "singleItem container-flex page-content" },
            [
              _vm.$store.state.items.isAddToBasketLoading != 0
                ? _c(
                    "div",
                    { staticClass: "item-loading-splash-screen" },
                    [
                      _c("icon", {
                        attrs: {
                          icon: "spinner",
                          loading:
                            _vm.$store.state.items.isAddToBasketLoading != 0
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "topItemContent" }, [
                _c(
                  "div",
                  {
                    staticClass: "itemImageGallery",
                    class: _vm.galleryDivision
                  },
                  [
                    _vm._t("image-carousel"),
                    _vm._v(" "),
                    _vm.cubeConfigLink
                      ? _c("a", {
                          staticClass:
                            "openLauraPlanner btn-sm btn-bkm-inverted btn",
                          attrs: { href: _vm.cubeConfigLink },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$translate(
                                "naturwohnenTheme::Template.openSetInPlanner"
                              )
                            )
                          }
                        })
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "itemDetails" }, [
                  _c(
                    "div",
                    { staticClass: "sticky" },
                    [
                      _c("h1", {
                        staticClass: "h2 title",
                        attrs: { "data-testing": "item-name" },
                        domProps: { innerHTML: _vm._s(_vm.variationName) }
                      }),
                      _vm._v(" "),
                      _c("feedback-average", {
                        staticClass: "box-feedback",
                        attrs: {
                          "show-empty-ratings": true,
                          "size-of-stars": "small",
                          "show-ratings-amount": true
                        }
                      }),
                      _vm._v(" "),
                      _vm.currentVariation.variation.availability.id == 1
                        ? _c(
                            "client-only",
                            [
                              _c("nw-availability", {
                                attrs: {
                                  standalone: true,
                                  "our-furniture": _vm.ourFurniture,
                                  avd: _vm.templateData
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("variation-measurement", {
                        attrs: {
                          "variation-properties": _vm.variationProperties
                        }
                      }),
                      _vm._v(" "),
                      _vm.variationBulletpoints.length
                        ? _c(
                            "ul",
                            {
                              staticClass: "list-unstyled variationBulletpoints"
                            },
                            [
                              _vm._l(_vm.variationBulletpoints, function(
                                bullet
                              ) {
                                return _c("li", {
                                  domProps: { innerHTML: _vm._s(bullet) }
                                })
                              }),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "learnMore",
                                  on: { click: _vm.scrollToDescription }
                                },
                                [_vm._v("Mehr erfahren")]
                              )
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.attributes.length
                        ? _c(
                            "div",
                            { staticClass: "mb-1" },
                            [_c("variation-select")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "priceBox" },
                        [
                          _vm.ourFurniture
                            ? _c("img", {
                                attrs: {
                                  src:
                                    "https://s3-eu-central-1.amazonaws.com/plentymarkets-public-92/3aiz45agf6oo/plugin/50/naturwohnentheme/images/assets/Naturwohnen.png",
                                  alt: "Naturwohnen"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("item-price", {
                            attrs: {
                              "show-cross-price": true,
                              "show-sale": _vm.showSale
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._t("after-price"),
                      _vm._v(" "),
                      _vm.showSale
                        ? _c("div", { staticClass: "shopSale" }, [
                            _c(
                              "div",
                              { staticClass: "shopSale-content" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "shopSale-text" },
                                  [
                                    _c("sale-countdown"),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "saleName",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$ceres.nwConfig.shopSale.saleLabel
                                        )
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "couponCopyCont" },
                                  [_c("coupon-copy")],
                                  1
                                ),
                                _vm._v(" "),
                                _c("sale-conditions")
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "section",
                        { staticClass: "accordion availabilityBox" },
                        [
                          _c(
                            "div",
                            { staticClass: "accordionItem availability" },
                            [
                              _c("img", {
                                staticClass: "nwicon",
                                attrs: {
                                  src:
                                    "https://cdn1.naturwohnen.de/frontend/naturwohnen/ico/check.svg",
                                  alt: "Verfuegbarkeit"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "client-only",
                                [
                                  _c("nw-availability", {
                                    attrs: {
                                      "our-furniture": _vm.ourFurniture,
                                      avd: _vm.templateData
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "accordionItem shipping" }, [
                            _c("img", {
                              staticClass: "nwicon",
                              attrs: {
                                src:
                                  "https://cdn1.naturwohnen.de/frontend/naturwohnen/ico/shipping.svg",
                                alt: "Versand und Rueckgabe"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "label" }, [
                              _vm._v(
                                "\n                                    Versand & Rückgabe\n                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "text" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "shipping",
                                  on: { click: _vm.showShipping }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.shipsWith.name)
                                    }
                                  }),
                                  _c("i", { staticClass: "fa fa-info" })
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.currentVariation.filter.isSalable &&
                          _vm.variationGroupedProperties.length
                            ? _c(
                                "div",
                                { staticClass: "accordionItem availability" },
                                [
                                  _c("img", {
                                    staticClass: "nwicon",
                                    attrs: {
                                      src:
                                        "https://cdn1.naturwohnen.de/frontend/naturwohnen/ico/construction.svg",
                                      alt: "Aufbauservice"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("order-property-list")
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "addToBasketContainer" }, [
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [_vm._t("before-add-to-basket")],
                          2
                        ),
                        _vm._v(" "),
                        _vm.currentVariation.item.itemType === "set"
                          ? _c(
                              "div",
                              { staticClass: "alert alert-info w-100" },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemSetInfo"
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "basketWishlist" },
                          [
                            _c("add-to-basket", {
                              attrs: {
                                "variation-id":
                                  _vm.currentVariation.variation.id,
                                "is-salable":
                                  !!_vm.currentVariation.filter &&
                                  _vm.currentVariation.filter.isSalable,
                                "has-children":
                                  !!_vm.currentVariation.filter &&
                                  _vm.currentVariation.filter.hasActiveChildren,
                                "interval-quantity":
                                  _vm.currentVariation.variation
                                    .intervalOrderQuantity || 1,
                                "minimum-quantity":
                                  _vm.currentVariation.variation
                                    .minimumOrderQuantity,
                                "maximum-quantity":
                                  !!_vm.currentVariation.variation
                                    .maximumOrderQuantity &&
                                  _vm.currentVariation.variation
                                    .maximumOrderQuantity > 0
                                    ? _vm.currentVariation.variation
                                        .maximumOrderQuantity
                                    : null,
                                "order-properties": _vm.currentVariation.properties.filter(
                                  function(prop) {
                                    return prop.property.isOderProperty
                                  }
                                ),
                                "has-order-properties":
                                  _vm.currentVariation.hasOrderProperties,
                                "has-required-order-property":
                                  _vm.currentVariation.hasRequiredOrderProperty,
                                "use-large-scale": false,
                                "show-quantity": true,
                                "item-url": _vm._f("itemURL")(
                                  _vm.currentVariation
                                ),
                                "is-variation-selected":
                                  _vm.isVariationSelected &&
                                  _vm.currentVariation.filter.isSalable,
                                "has-price": _vm._f("hasItemDefaultPrice")(
                                  _vm.currentVariation
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("add-to-wish-list", {
                              attrs: {
                                "variation-id":
                                  _vm.currentVariation.variation.id
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "share d-none" },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$translate(
                                    "naturwohnenTheme::Template.shareLabel"
                                  )
                                ) +
                                "\n                                "
                            ),
                            _c("share", {
                              attrs: {
                                title:
                                  _vm.currentVariation.texts.name1 +
                                  _vm.$translate(
                                    "naturwohnenTheme::Template.shareTitleSuffix"
                                  ),
                                mode: "text"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [_vm._t("after-add-to-basket")],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _vm._t("additional-content-after-add-to-basket"),
                      _vm._v(" "),
                      _vm._t("additional-content-after-vat")
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.qualityIcons.length > 0
                ? _c(
                    "div",
                    { ref: "qualityIcons", staticClass: "qualityIcons" },
                    [
                      _c("div", { staticClass: "splide__track" }, [
                        _c(
                          "div",
                          { staticClass: "splide__list" },
                          _vm._l(_vm.qualityIcons, function(icon) {
                            return _c(
                              "div",
                              { staticClass: "icon splide__slide" },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "https://cdn02.plentymarkets.com/3aiz45agf6oo/frontend/naturwohnen/ico/" +
                                      icon.icon +
                                      ".svg"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(icon.name) }
                                })
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "itemContent" }, [
                _vm.qualityIcons.length > 0
                  ? _c(
                      "div",
                      { staticClass: "qualityIcons d-none" },
                      _vm._l(_vm.qualityIcons, function(icon) {
                        return _c("i", { staticClass: "nw-icon", class: icon })
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "itemDescription" }, [
                  _vm.hasProperty(21)
                    ? _c(
                        "section",
                        { staticClass: "technicalImage" },
                        _vm._l(_vm.variationProperties, function(property) {
                          return property.id === 21
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://cdn1.naturwohnen.de/propertyItems/" +
                                      property.value,
                                    "data-fancybox": ""
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "https://cdn1.naturwohnen.de/propertyItems/" +
                                        property.value,
                                      alt: "Technical Image"
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "section",
                    {
                      staticClass: "textContent accordion",
                      attrs: { id: "product-accordion" }
                    },
                    [
                      _c("div", { staticClass: "description" }, [
                        _c("button", {
                          staticClass: "toggleBox",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#product-description"
                          },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$translate(
                                "naturwohnenTheme::Template.description"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _vm.hasProperty(291)
                          ? _c("div", {
                              staticClass: "textbox collapse show",
                              attrs: { id: "product-description" },
                              domProps: {
                                innerHTML: _vm._s(_vm.getProperty(291).value)
                              }
                            })
                          : _c("div", {
                              staticClass: "textbox collapse show",
                              attrs: { id: "product-description" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.currentVariation.texts.description
                                )
                              }
                            })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "technicalData" }, [
                        _c("button", {
                          staticClass: "toggleBox collapsed",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#tech-data"
                          },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$translate(
                                "naturwohnenTheme::Template.technicalData"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "textbox collapse",
                            attrs: { id: "tech-data" }
                          },
                          [
                            _c("div", {
                              staticClass: "techBullets",
                              domProps: {
                                innerHTML: _vm._s(_vm.technicalDataText)
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "itemNumber" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "naturwohnenTheme::Template.singleItemNumber"
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.currentVariation.item.id +
                                      "-" +
                                      _vm.currentVariation.variation.id
                                  ) +
                                  "\n                                "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.showResponsible
                              ? _c("div", { staticClass: "responsible" }, [
                                  _c("h4", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "naturwohnenTheme::Template.responsibleHeadline"
                                        )
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "naturwohnenTheme::Template.responsibleDescription"
                                        )
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "card" }, [
                                    _c("div", { staticClass: "p-0" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsibleName
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "p-0" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsibleStreet
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsibleHouseNo
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "p-0" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsiblePostCode
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsibleTown
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.currentVariation.item.manufacturer
                                        .responsibleCountryObject
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.currentVariation.item
                                                    .manufacturer
                                                    .responsibleCountryObject
                                                    .name
                                                ) +
                                                "\n                                            "
                                            )
                                          ])
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "p-0" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsibleEmail
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "p-0" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsiblePhoneNo
                                          )
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.hasProperty(191)
                        ? _c("div", { staticClass: "variationCare" }, [
                            _c(
                              "button",
                              {
                                staticClass: "toggleBox collapsed",
                                attrs: {
                                  "data-toggle": "collapse",
                                  "data-target": "#variation-care"
                                }
                              },
                              [_vm._v("Pflegehinweise")]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "textbox collapse",
                              attrs: { id: "variation-care" },
                              domProps: {
                                innerHTML: _vm._s(_vm.getProperty(191).value)
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "deliveryInfo" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "textbox collapse",
                            attrs: { id: "delivery-info" }
                          },
                          [
                            _c("div", { staticClass: "shippingBox" }, [
                              _c("div", { staticClass: "head" }, [
                                _c("span", {
                                  staticClass: "title",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.shipsWith.name)
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "price" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(
                                        _vm.defaultShippingCosts
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "text",
                                domProps: {
                                  innerHTML: _vm._s(_vm.shipsWith.text)
                                }
                              })
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "crossSelling accessories" },
                [_vm._t("cross-selling-accessory")],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "additionalInfo" },
                [
                  _vm._t("series-categories"),
                  _vm._v(" "),
                  _vm._t("material-categories"),
                  _vm._v(" "),
                  _c("manufacturer")
                ],
                2
              ),
              _vm._v(" "),
              _vm._t("item-list-container")
            ],
            2
          )
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      ),
      _vm._v(" "),
      _vm._t("feedback-container"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crossSelling products" },
        [_vm._t("cross-selling-similar")],
        2
      ),
      _vm._v(" "),
      _c("slide-content", {
        attrs: { name: "aufbauservice", "category-id": 1297 }
      }),
      _vm._v(" "),
      _c("slide-content", {
        attrs: { name: "furniture_deliverytime", "category-id": 1304 }
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "toggleBox collapsed",
        attrs: { "data-toggle": "collapse", "data-target": "#delivery-info" }
      },
      [
        _c("i", {
          staticClass: "nw-icon lieferung_icon",
          attrs: { alt: "Fairer Versand" }
        }),
        _vm._v(" Versandservice")
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }